import type { JSX } from 'react';
import { Chip } from '@heroui/react';

import type { MemberStatus } from '~/types';

interface StatusBadgeProps {
  status: MemberStatus;
  size?: 'sm' | 'md' | 'lg';
}

const statusColor: Record<MemberStatus, 'success' | 'warning' | 'danger'> = {
  active: 'success',
  invited: 'warning',
  suspended: 'danger',
};

export function StatusBadge({ size = 'sm', status }: StatusBadgeProps): JSX.Element {
  return (
    <Chip className="capitalize" color={statusColor[status]} size={size}>
      {status}
    </Chip>
  );
}
